import { combineReducers, Reducer } from "redux"
import { styleReducer, styleState } from './style'
import { userReducer, userState } from './user'
import { customerState, customerReducer } from "./customer"
import { institutionState, institutionReducer } from "./institution"
import { detectorState, detectorReducer } from "./detector"

export interface RootState {
    style: styleState,
    user: userState,
    customer: customerState,
    institution: institutionState,
    detector: detectorState
}

export const rootReducer: Reducer<RootState> = combineReducers({
    'style': styleReducer,
    'user': userReducer,
    'customer': customerReducer,
    'institution': institutionReducer,
    'detector': detectorReducer
})